import { IncomingMessage, ServerResponse } from 'http';
import { defineMessage } from 'react-intl';

export type EventListingError = {
  statusCode?: number;
  error?: string | undefined;
};

export type ErrorResponse = {
  statusCode: number;
  message: string;
  description: string;
};

export const errorMessages = {
  genericError: {
    message: defineMessage({ id: 'Something went wrong' }),
    description: defineMessage({ id: "We can't find what you looked for, but we have other events you might like." }),
  },
};

const CLIENT_ERROR_MAP: Record<number, ErrorResponse> = {
  [400]: {
    statusCode: 400,
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
  [403]: {
    statusCode: 502,
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
  [404]: {
    statusCode: 404,
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
  [500]: {
    statusCode: 500,
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
  [502]: {
    statusCode: 502,
    message: errorMessages.genericError.message.id,
    description: errorMessages.genericError.description.id,
  },
};

export const handle404Error = (res: ServerResponse<IncomingMessage>) => {
  res.statusCode = 404;
  return {
    props: {
      error: {
        statusCode: 404,
        message: errorMessages.genericError.message.id,
        description: errorMessages.genericError.description.id,
      },
      context: null,
      canonicalUrl: null,
      locale: 'en',
    },
  };
};

const getCustomErrorResponse = (res: ServerResponse<IncomingMessage>, statusCode: number) => {
  const clientError = CLIENT_ERROR_MAP[statusCode] || CLIENT_ERROR_MAP[500];
  res.statusCode = clientError.statusCode;
  return {
    props: {
      error: clientError,
      context: null,
      canonicalUrl: null,
      locale: 'en',
    },
  };
};

export const handleError = (res: ServerResponse<IncomingMessage>, error: EventListingError) => {
  const statusCode = error.statusCode || 400;
  res.statusCode = statusCode >= 500 ? 500 : statusCode;
  console.error(`Error ${error.statusCode}: ${error.error || 'Unknown error'}`);
  return getCustomErrorResponse(res, res.statusCode);
};
